// TODO: Patron Redux en revisión de cargos en proceso
import axios from "axios";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Button, Col, Container, Row, TabPane } from "reactstrap";
import BaseInput from "../../../../toolkit/baseInput";
import ModalFrame from "../../../../toolkit/modalFrame";
import IAction from "../../../../types/IAction";
import { userHasPermission } from "../../../../utils/accessTree";
import constants, {
  PARTNER_MEMB_PENDIENTE_PAGO_STATUS
} from "../../../../utils/constants";
import { handleRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import permissionCodes from "../../../../utils/permissionCodes";
import {
  createPaymentLineForPreactivationPayment,
  generateIgualaAnnuityCharge,
  generateIgualaMaintenanceCharge
} from "../../../actions/partners";
import {
  deletePaymentLineRequest,
  getPaymentLineRequest
} from "../../../actions/paymentLines";
import { createMaintenanceDiscountRequest } from "../../../actions/products";
import IFrameModal from "../../common/iframeModal/iFrameModal";
import { Partner } from "../interfaces";
import CreateIgualaChargeModal from "./createIgualaChargeModal/createIgualaChargeModal";
import CreateMaintenanceChargeModal from "./createMaintenanceChargeModal/createMaintenanceChargeModal";
import MovementsTable from "./movementsTable";
import s from "./styles.scss";

const ESTATUS_MEMBRESIA_PENDIENTE_PAGO = [PARTNER_MEMB_PENDIENTE_PAGO_STATUS];

interface Props {
  partner: Partner;
  movementsList: object[];
  idMembresia: string;
  idMembresiaSocio: string;
  listHistoricalRebilling: any;
  sendMovementEmail: (id: number, email: string) => any;
  toggleBill: (storageId: number) => any;
  toggleBillXml: (uuid: string) => IAction;
  getMovements: () => any;
  historicalRebilling: (ventaId: string) => IAction;
  invalidateStateValue: (fieldName: string, value: any) => void;
  refreshPartner: () => void;
  descripcionTraspaso: any;
  membershipBlocked: boolean;
  membershipBlockedReactivacion: boolean;
  estaVetado?: boolean;
  annuitiesAvailableMaintenances: any[];
}

interface State {
  isOpen: boolean;
  amount: number;
  hasProcessing: boolean;

  isModalCurrentMonthChargeOpen: boolean;
  isModalIgualaChargeOpen: boolean;
  igualaAmount: number;
  igualaCpiId: number;
  igualaType: String;
  isCatModalCurrentMonthChargeEnabled: boolean;
  saving: boolean;
  waiting: boolean;
  iFrameModalIsOpen: boolean;
  iFrameModalSrc: String;
  lineaPagoData: any;
}

class TabMovements extends React.Component<Props, State> {
  state = {
    isOpen: false,
    amount: null,
    hasProcessing: false,

    isModalCurrentMonthChargeOpen: false,
    isModalIgualaChargeOpen: false,
    igualaAmount: null,
    igualaCpiId: null,
    igualaType: null,
    isCatModalCurrentMonthChargeEnabled: true,

    saving: false,
    waiting: false,

    iFrameModalIsOpen: false,
    iFrameModalSrc: null,
    lineaPagoData: null
  };

  getTablePageSize = () => {
    const defPageSize: number = 20;
    return (this.props.movementsList || []).length
      ? this.props.movementsList.length + 1
      : defPageSize;
  };

  toggleModal = () => this.setState({ isOpen: !this.state.isOpen });

  toggleModalCurrentmonthCharge = () => {
    this.setState({
      isModalCurrentMonthChargeOpen: !this.state.isModalCurrentMonthChargeOpen
    });
  };

  toggleModalIgualaCharge = () => {
    this.setState({
      isModalIgualaChargeOpen: !this.state.isModalIgualaChargeOpen,
      igualaType: "MANTENIMIENTO"
    });
  };

  toggleModalIgualaAnnuityCharge = cpiId => {
    this.setState({
      isModalIgualaChargeOpen: true,
      igualaType: "ANUALIDAD",
      igualaCpiId: cpiId
    });
  };

  handleDiscountCreation = () => {
    createMaintenanceDiscountRequest({
      membresiaSocioId: this.props.idMembresiaSocio,
      productoId: this.props.idMembresia,
      monto: this.state.amount
    })
      .then(() => {
        this.toggleModal();
        this.props.invalidateStateValue("movementsList", []);
        this.props.getMovements();
      })
      .catch(handleRequestError);
  };

  handleGenerateIgualaCharge = params => {
    infoNotification("Generando cargo de iguala de plan");

    this.setState({ saving: true }, () => {
      generateIgualaMaintenanceCharge(this.props.idMembresiaSocio, params)
        .then(() => {
          this.setState({
            isModalIgualaChargeOpen: false,
            saving: false
          });
          infoNotification("Cargo de iguala de plan generado correctamente...");
          this.props.invalidateStateValue("movementsList", []);
          this.props.getMovements();
        })
        .catch(handleRequestError);
    });
  };

  handleGenerateIgualaAnnuitieCharge = params => {
    infoNotification("Generando cargo de iguala de anualidad");

    this.setState({ saving: true }, () => {
      generateIgualaAnnuityCharge(this.props.idMembresiaSocio, params)
        .then(() => {
          this.setState({
            isModalIgualaChargeOpen: false,
            saving: false
          });
          successNotification(
            "Cargo de iguala de anualidad generado correctamente..."
          );
          this.props.invalidateStateValue("movementsList", []);
          this.props.getMovements();
        })
        .catch(handleRequestError);
    });
  };

  handleInputChange = e => this.setState({ amount: e.target.value });
  handleInputIgualaChange = e =>
    this.setState({ igualaAmount: e.target.value });

  async componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.idMembresiaSocio != this.props.idMembresiaSocio) {
      this.showProcessingAlert(this.props.idMembresiaSocio);
    }
  }

  async componentDidMount() {
    this.showProcessingAlert(this.props.idMembresiaSocio);
  }

  async showProcessingAlert(idMembresiaSocio) {
    try {
      await axios.get(constants.BASE_URL + "/api/partners/has-processing", {
        withCredentials: true,
        params: {
          idMembresiaSocio
        }
      });

      this.setState({
        hasProcessing: true
      });
    } catch (error) {
      this.setState({
        hasProcessing: false
      });
    }
  }

  isMembershipBlocked = () => {
    return (
      !!this.props.membershipBlocked ||
      !!this.props.membershipBlockedReactivacion
    );
  };

  isMembershipPendientePago = () => {
    return (
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_PENDIENTE_PAGO.includes(
        this.props.partner.estatusMembresia
      )
    );
  };

  invalidateMovementsData = () => {
    this.props.invalidateStateValue("movementsList", []);
    this.props.getMovements();
  };

  render() {
    const {
      movementsList,
      toggleBill,
      toggleBillXml,
      sendMovementEmail
    } = this.props;

    const { igualaType } = this.state;

    return (
      <TabPane className="my-2" tabId="7">
        {userHasPermission(
          permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_ADD_DISCOUNT
        ) && (
          <ModalFrame
            title={"Agregar descuento de plan"}
            isOpen={this.state.isOpen}
            toggle={this.toggleModal}
          >
            <Container>
              <p>
                Se generará un código de descuento aplicable al último cargo de
                plan no pagado existente. En caso de no existir, se generará el
                cargo de plan del siguiente mes con el descuento aplicado
              </p>
              <Row>
                <p className={`w-100`}>
                  <BaseInput
                    label={"Cantidad"}
                    name="cantidadDescuento"
                    type="number"
                    id="cantidadDescuento"
                    placeholder="Descuento"
                    onChange={this.handleInputChange}
                  />
                </p>
              </Row>
              <Row>
                <Col className="text-right">
                  <Button
                    color="secondary"
                    onClick={this.toggleModal}
                    style={{ marginRight: "15px" }}
                  >
                    Cerrar
                  </Button>
                  <Button
                    color="primary"
                    onClick={this.handleDiscountCreation}
                    disabled={(() =>
                      !this.state.amount ||
                      parseFloat(this.state.amount) <= 0)()}
                  >
                    Generar descuento
                  </Button>
                </Col>
              </Row>
            </Container>
          </ModalFrame>
        )}

        {(userHasPermission(
          permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_GENERATE_IGUALA_MAINTENANCE
        ) ||
          userHasPermission(
            permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_GENERATE_IGUALA_ANUALIDAD
          )) && (
          <CreateIgualaChargeModal
            annuitiesAvailableMaintenances={
              this.props.annuitiesAvailableMaintenances
            }
            partner={this.props.partner}
            cotizacionProductoItemId={this.state.igualaCpiId}
            igualaType={this.state.igualaType}
            isOpen={this.state.isModalIgualaChargeOpen}
            isSaving={this.state.saving}
            onCancel={this.toggleModalIgualaCharge}
            onOk={params => {
              const { igualaType } = this.state;
              switch (igualaType) {
                case "MANTENIMIENTO":
                  this.handleGenerateIgualaCharge(params);
                  break;
                case "ANUALIDAD":
                  this.handleGenerateIgualaAnnuitieCharge(params);
                  break;
                default:
                  errorNotification("No se especifico un tipo de iguala");
                  break;
              }
            }}
          />
        )}

        {userHasPermission(
          permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_GENERATE_CURRENT_MONTH
        ) && (
          <CreateMaintenanceChargeModal
            idMembresiaSocio={this.props.idMembresiaSocio}
            isOpen={this.state.isModalCurrentMonthChargeOpen}
            cancel={() => {
              this.setState({ isModalCurrentMonthChargeOpen: false });
            }}
            success={() => {
              this.setState({ isModalCurrentMonthChargeOpen: false });
              this.props.invalidateStateValue("movementsList", []);
              this.props.getMovements();
            }}
          />
        )}

        <IFrameModal
          isOpen={this.state.iFrameModalIsOpen}
          title={
            "Pago de membresía y cargos asociados al plan / anualidad en línea"
          }
          okTitle={"Validar pago"}
          waiting={this.state.waiting}
          ok={() => {
            const { idMembresiaSocio } = this.props;
            const { lineaPagoData } = this.state;
            this.setState({ waiting: true });

            setTimeout(() => {
              getPaymentLineRequest(lineaPagoData.id)
                .then(({ data: lp }) => {
                  if (["COBRADA_MIT", "FACTURADA"].includes(lp.estatus || "")) {
                    this.setState({
                      iFrameModalSrc: null,
                      iFrameModalIsOpen: false,
                      lineaPagoData: null,
                      waiting: false
                    });

                    this.props.invalidateStateValue("paymentMethods", []);
                    this.props.getMovements();
                    this.props.refreshPartner();
                  } else {
                    errorNotification(
                      "No se ha detectado el pago realizado. Favor de volver a comprobar el pago."
                    );
                    this.setState({ waiting: false });
                  }
                })
                .catch(error => {
                  this.setState({ waiting: false });
                  handleRequestError(error);
                });
            }, 8000);

            /* markPaymentLineAsCompleted(idMembresiaSocio, lineaPagoData)
              .then(() => {
                this.setState({
                  iFrameModalSrc: null,
                  iFrameModalIsOpen: false,
                  lineaPagoData: null,
                  waiting: false
                });

                this.props.invalidateStateValue("movementsList", []);
                this.props.getMovements();

                if (this.props.refreshPartner) {
                  this.props.refreshPartner();
                }
              })
              .catch(error => {
                this.setState({ waiting: false });
                handleRequestError(error);
              }); */
          }}
          cancel={() => {
            const { lineaPagoData } = this.state;
            this.setState({ waiting: true });

            deletePaymentLineRequest(lineaPagoData.id)
              .then(() => {
                this.setState({
                  iFrameModalSrc: null,
                  iFrameModalIsOpen: false,
                  lineaPagoData: null,
                  waiting: false
                });
              })
              .catch(error => {
                this.setState({ waiting: false });
                handleRequestError(error);
              });
          }}
          src={this.state.iFrameModalSrc}
        />

        <Container className="p-0">
          <Row>
            <Col md="5">
              <div className="m-4">
                {userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_GENERATE_IGUALA_MAINTENANCE
                ) &&
                  !this.isMembershipBlocked() &&
                  !this.props.estaVetado && (
                    <Button
                      className="bg-info mr-4"
                      size="sm"
                      onClick={this.toggleModalIgualaCharge}
                    >
                      Generar cargo de iguala de plan
                    </Button>
                  )}

                {this.isMembershipPendientePago() && (
                  <Button
                    className="bg-secondary mr-4"
                    size="sm"
                    disabled={!!this.state.waiting}
                    onClick={e => {
                      e.preventDefault();

                      this.setState({ waiting: true });
                      infoNotification("Generando ");

                      const { idMembresiaSocio } = this.props;
                      createPaymentLineForPreactivationPayment(idMembresiaSocio)
                        .then(({ data }) => {
                          console.info(data);
                          this.setState({ waiting: false });

                          this.setState({
                            lineaPagoData: data,
                            iFrameModalSrc: data.url,
                            iFrameModalIsOpen: true
                          });
                        })
                        .catch(error => {
                          this.setState({ waiting: false });
                          handleRequestError(error);
                        });
                    }}
                  >
                    Pagar en línea
                  </Button>
                )}
              </div>
            </Col>
            <Col md="7">
              <div className="m-4 text-right">
                {userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_GENERATE_CURRENT_MONTH
                ) &&
                  !this.isMembershipBlocked() &&
                  !this.props.estaVetado && (
                    <Button
                      className="primaryButton"
                      size="sm"
                      onClick={this.toggleModalCurrentmonthCharge}
                    >
                      Generar cargo de plan
                    </Button>
                  )}

                {userHasPermission(
                  permissionCodes.PARTNER_MEMBERSHIP_TAB_MOVEMENTS_ADD_DISCOUNT
                ) &&
                  !this.isMembershipBlocked() &&
                  !this.props.estaVetado && (
                    <Button
                      className="ml-4"
                      size="sm"
                      onClick={this.toggleModal}
                    >
                      Agregar descuento de plan
                    </Button>
                  )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                hidden={!this.state.hasProcessing}
                className="alert alert-warning"
                style={{ padding: "6px 8px" }}
                role="alert"
              >
                <p className="m-0">
                  Algunos de los movimientos pendientes se estan procesando como
                  cargos automáticos; por favor, espere la resolución para
                  manipularlos manualmente en el carrito de compras.
                </p>
              </div>
            </Col>
            <Col>
              <Row>
                <Col>
                  <div className="m-3">
                    <div
                      style={{
                        display: "inline",
                        padding: "0px 20px",
                        marginRight: "8px",
                        background: "#ddd",
                        border: "solid 1px #000"
                      }}
                    ></div>
                    <span>
                      Cargos asociados al plan <b>NO</b> habilitados para{" "}
                      <b>CAT</b>
                    </span>
                  </div>
                </Col>
                <Col>
                  <div className="m-3">
                    <div
                      style={{
                        display: "inline",
                        padding: "0px 20px",
                        marginRight: "8px",
                        background: "#fff3cd",
                        border: "solid 1px #000"
                      }}
                    ></div>
                    <span>Cargos asociados al plan en proceso CAT activo</span>
                  </div>
                </Col>
              </Row>
              <MovementsTable
                historicalRebilling={this.props.historicalRebilling}
                listHistoricalRebilling={this.props.listHistoricalRebilling}
                loadingMovements={false}
                sendMovementEmail={sendMovementEmail}
                toggleBill={toggleBill}
                toggleBillXml={toggleBillXml}
                movementsList={movementsList}
                tablePageSize={this.getTablePageSize()}
                descripcionTraspaso={this.props.descripcionTraspaso}
                membershipBlocked={this.isMembershipBlocked()}
                refreshPartner={this.props.refreshPartner}
                invalidateMovementsData={this.invalidateMovementsData}
                toggleModalIgualaAnnuityCharge={
                  this.toggleModalIgualaAnnuityCharge
                }
                estaVetado={this.props.estaVetado}
              />
            </Col>
          </Row>
        </Container>
      </TabPane>
    );
  }
}

export default withStyles(s)(TabMovements);
